
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";
import { Strategy } from "@/types/strategy-types";

export const useUpdateStrategy = (loadStrategiesCallback: () => Promise<void>) => {
  const [isUpdating, setIsUpdating] = useState(false);
  const { toast } = useToast();

  const updateStrategy = async (id: string, updatedStrategy: Partial<Strategy>) => {
    setIsUpdating(true);
    try {
      // Create a strategy object to update without performance metrics fields
      const strategyToUpdate = { ...updatedStrategy };
      
      // Normalize plan value
      if (strategyToUpdate.plan) {
        strategyToUpdate.plan = strategyToUpdate.plan === 'premium' || strategyToUpdate.plan === 'pro' 
          ? 'premium' 
          : 'free';
      }

      // Normalize risk level to be between 1-3
      if (strategyToUpdate.risk_level) {
        strategyToUpdate.risk_level = Math.min(Math.max(strategyToUpdate.risk_level, 1), 3);
      }

      // Ensure required fields are present for the update
      if (strategyToUpdate.name === '') delete strategyToUpdate.name;
      if (strategyToUpdate.exchange === '') delete strategyToUpdate.exchange;
      if (strategyToUpdate.strategy_provider_id === '') delete strategyToUpdate.strategy_provider_id;
      
      console.log("Updating strategy:", id, strategyToUpdate);
      
      const { error } = await supabase
        .from('strategy')
        .update(strategyToUpdate)
        .eq('id', id);

      if (error) {
        console.error("Supabase error:", error);
        throw error;
      }

      await loadStrategiesCallback();
      toast({
        title: "Success",
        description: "Strategy updated successfully",
      });
    } catch (error) {
      console.error('Error updating strategy:', error);
      toast({
        title: "Error",
        description: "Failed to update strategy",
        variant: "destructive",
      });
      throw error;
    } finally {
      setIsUpdating(false);
    }
  };

  return { updateStrategy, isUpdating };
};
